import {useState, useEffect} from "react";

const breakpointValues = {
    small: 650,
    medium: 768,
    large: 1176,
};

export function useBreakpoint() {
    const [breakpoints, setBreakpoints] = useState({
        isSmall: window.innerWidth >= breakpointValues.small,
        isMedium: window.innerWidth >= breakpointValues.medium,
        isLarge: window.innerWidth >= breakpointValues.large,
    });

    useEffect(() => {
        const handleResize = () => {
            setBreakpoints({
                isSmall: window.innerWidth >= breakpointValues.small,
                isMedium: window.innerWidth >= breakpointValues.medium,
                isLarge: window.innerWidth >= breakpointValues.large,
            });
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return breakpoints;
}
